import React, { useState, useEffect } from "react";
import useAccordionScroll from "../../../../hooks/useAccordionScroll";

const AccordionItem = ({ title, content, isOpen, onToggle, index, isLast }) => {
  const { accordionRef, scrollToAccordionOnOpen } = useAccordionScroll();

  // Usar o hook para scroll automático quando o accordion é aberto
  useEffect(() => {
    if (isOpen) {
      scrollToAccordionOnOpen(true, 100);
    }
  }, [isOpen, scrollToAccordionOnOpen]);

  return (
    <div
      ref={accordionRef}
      style={{ borderBottom: isLast ? "none" : "1px solid var(--extra-line)" }}
    >
      <div
        className="w-full flex justify-content-between cursor-pointer align-items-center py-4"
        onClick={onToggle}
      >
        <span className="flex align-items-center gap-4">
          <span className="font-bold text-lg" style={{ color: "var(--extra-green)" }}>
            0{index + 1}
          </span>
          <span className="text-md font-semibold" style={{ color: "var(--extra-ink)" }}>
            {title}
          </span>
        </span>
        <span
          className={`align-self-center transition-transform duration-200 ${
            isOpen ? "transform rotate-180" : ""
          }`}
        >
          <i className="pi pi-chevron-down" style={{ color: "var(--extra-green)" }}></i>
        </span>
      </div>
      <div className={`overflow-hidden ${isOpen ? "pb-4" : "max-h-0"}`}>
        <div className="text-sm" style={{ color: "var(--extra-body)" }}>
          {content}
        </div>
      </div>
    </div>
  );
};

const LandingAccordionComponent = (questions) => {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (id) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <div className="w-full mx-auto">
      {questions.questions.map((question, index) => (
        <AccordionItem
          key={question.id}
          index={index}
          title={question.title}
          content={question.content}
          isOpen={openItems.has(question.id)}
          onToggle={() => toggleItem(question.id)}
          isLast={index === questions.questions.length - 1}
        />
      ))}
    </div>
  );
};

export default LandingAccordionComponent;
